export enum colors {
  lightBlue = '#D0E1FF',
  lightRed = '#FF8389',
  lightGreen = '#A7F0BA',
}
